<template>
  <div class="hero-news" @click="openDetails(onenews.new_id)">
    <div class="img">
      <img :src="imageLink(onenews.new_image)" />
    </div>
    <div class="data-news">
      <div class="data">
        <h2>{{ onenews.new_title }}</h2>
        <p class="newsdate">
          <img
            src="@/assets/newImges/calendar-solid-light.svg"
            alt=""
            srcset=""
          />{{ onenews.new_date }}
        </p>
        <!-- <div
        v-if="onenews.new_article"
        class="description"
        v-html="this.description() + '...'"
      ></div> -->
        <p class="autor">@ {{ onenews.new_author }}</p>
      </div>
      <div class="read-more">
        {{ $t("news.read") }}
        <img src="@/assets/newImges/Vector.svg" alt="" srcset="" />
      </div>
    </div>
  </div>
</template>

<script>
// import eventBus from "@/shared/eventBus.js";
import { baseURL } from "@/api";

export default {
  name: "HeroNews",
  props: {
    onenews: {
      required: true,
      type: Object
    }
  },
  methods: {
    imageLink(image) {
      return baseURL + image;
    },
    description() {
      return this.onenews.new_article.substring(0, 300);
    },
    openDetails(id) {
      let params = Object.assign({}, this.$route.params);
      params.id = id;
      this.$router.push({ name: "NewsDescriptionPage", params: params });
    }
    // openNewsModal(onenews) {
    //   let params = {
    //     modalData: onenews,
    //     component: "NewsDescription"
    //   };
    //   eventBus.$emit("openModal", params);
    // }
  }
};
</script>

<style lang="scss" scoped>
.hero-news {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  max-width: 100%;
  cursor: pointer;
  margin-bottom: 67px;
  padding: 30px;
  background-color: $gray-blue-100;
  border: 1px solid $gray-blue-700;
  border-radius: 12px;

  .img {
    /* width: 25%; */
    width: 638px;
    max-width: calc(52% - 25px);
    height: 447px;
    // aspect-ratio: 4/2.7;
    display: block;
    position: relative;
    overflow: hidden;
    border-radius: 12px;

    img {
      /*  position: absolute;
        top: 0;
        left: 0;
        width: 100%;
  */
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .data-news {
    box-sizing: border-box;
    width: calc(48% - 25px);
    height: 323px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  h2 {
    font-weight: 400;
    font-style: Regular;
    font-size: 26px;
    line-height: 34px;
    letter-spacing: 0%;
    color: $blue-1000;
  }

  .newsdate {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;

    color: $gray-blue-1300;
    display: flex;
    align-items: center;
    img {
      margin-right: 17px;
    }
  }

  .autor {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0%;

    color: $light-blue-600;
  }
  .read-more {
    font-family: Figtree;
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0%;
    color: $blue-600;
    display: flex;
    align-items: center;
    img {
      margin-left: 10px;
    }
  }
}
@media only screen and (max-width: 1100px) {
  .hero-news {
    .img {
      /* width: 25%; */
      width: 638px;
      max-width: calc(52% - 25px);
      height: 323px;
      display: block;

      overflow: hidden;
      border-radius: 12px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .hero-news {
    margin-bottom: 37px;
    padding: 10px;

    border-radius: 12px;

    .img {
      /* width: 25%; */

      max-width: calc(52% - 15px);
      height: 323px;
      display: block;

      overflow: hidden;
      border-radius: 12px;
    }

    .data-news {
      box-sizing: border-box;
      width: calc(48% - 15px);
      height: 323px;
    }
    h2 {
      font-size: 24px;
      line-height: 32px;
    }

    .newsdate {
      font-size: 16px;
      line-height: 22px;

      img {
        margin-right: 7px;
      }
    }

    .autor {
      font-size: 14px;
      line-height: 30px;
    }
    .read-more {
      font-size: 15px;
      line-height: 26px;

      img {
        width: 13px;
      }
    }
  }
}
</style>
